(function () {
    angular.module('active-email-engagement-condition.dir', [])
        .directive('activeEmailEngagementCondition', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeEmailEngagementCondition]);

    function activeEmailEngagementCondition($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', '$http', function ($scope, $http) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.breakUrl = () => {
                    return $scope.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                $scope.parseDescription = function (desc) {
                    var textToParse = desc;
                    if (textToParse) {
                        if ( textToParse.length > 15) {
                            textToParse = textToParse.slice(0, 15) + '...';
                            //Desc < 15
                        }  else if (textToParse.length < 15) {
                            textToParse = textToParse;
                        }
                    } else {
                        textToParse = $scope.translate('commons.description');
                    }

                    return textToParse;
                };

                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.displayConditionMenu = [];
                    } else {
                        $scope.displayList = false;
                    }
                    $scope.displaySubMenu = false;
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function() {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function() {
                    if($scope.displayConditionMenu){
                        var rectangleMenu = $scope.displayConditionMenu.length > 0;
                    }

                    if($scope.displayList || $scope.displaySubMenu || rectangleMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        }else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.displayConditionMenu = [];
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function() {
                    $scope.displayList = false;
                };

            }],
            link: function (scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-email-engagement');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.emailList = helpers.jbContainsSendEmail();
                    scope.numbers = '0';
                    //Gettiing Node by ID (Send Email node)
                    var emailConnection = helpers.getLoaderConnectionById(scope.data.emailNode);
                    //Adding Email node name to the scope
                    scope.emailNodeName = emailConnection.emailData.EmailName;
                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function(evt, data) {
                        if(data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('newActiveEmail' + scope.data.emailNode, function(evt, summary) {
                        if(summary && summary.emailName) {
                            scope.emailNodeName = summary.emailName;
                        }
                    });
                }
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/conditions/active-email-engagement.js